import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from '../../../redux/axios';

const initialState = {
  Overview: [],
  ProcessBreakDown: [],
  AllProcessCount: [],
  ResponseTime: [],
  isFetching: false,
  isProcessBreakDownSuccess: false,
  isAllProcessCountSucess: false,
  isOverviewSuccess: false,
  isResponseTimeSuccess: false,
  isError: false,
  errorMessage: '',
};

export const getOverview = createAsyncThunk(
  'api/dashboard/overview/',
  async (udata, thunkAPI) => {
    try {
      const { auth } = thunkAPI.getState()
      let tokenStr = auth.user.token;
      let response = await axios({
        url: `/api/dashboard/overview/`,
        method: 'get',
        headers: {
          "Authorization": `Bearer ${tokenStr}`
        }
      })

      let data = response.data;
      if (response.status === 200) {
        return data;
      }
      else if (data.code === 200) {
        return data;
      }
      else {
        return thunkAPI.rejectWithValue(data);
      }
    } catch (err) {
      if (!err.response) {
        throw err
      }

      return thunkAPI.rejectWithValue(err.response.data)
    }
  }
);

export const getAllProcessCount = createAsyncThunk(
  'dashboard/allProcessChart',
  async (udata, thunkAPI) => {
    try {
      const { auth } = thunkAPI.getState()
      let tokenStr = auth.user.token;
      let response = await axios({
        url: `/api/dashboard/allProcessChart`,
        method: 'get',
        headers: {
          "Authorization": `Bearer ${tokenStr}`
        }
      })

      let data = response.data;
      if (response.status === 200) {
        return data;
      }
      else if (data.code === 200) {
        return data;
      }
      else {
        return thunkAPI.rejectWithValue(data);
      }
    } catch (err) {
      if (!err.response) {
        throw err
      }

      return thunkAPI.rejectWithValue(err.response.data)
    }
  }
);



export const getProcessBreakDown = createAsyncThunk(
  'dashboard/processBreakdown?typeName',
  async (udata, thunkAPI) => {
    try {
      const { auth } = thunkAPI.getState()
      let tokenStr = auth.user.token;
      let response = await axios({
        url: `/api/dashboard/processBreakdown?typeName=${udata}`,
        method: 'get',
        headers: {
          "Authorization": `Bearer ${tokenStr}`
        }
      })

      let data = response.data;
      if (response.status === 200) {
        return data;
      }
      else if (data.code === 200) {
        return data;
      }
      else {
        return thunkAPI.rejectWithValue(data);
      }
    } catch (err) {
      if (!err.response) {
        throw err
      }

      return thunkAPI.rejectWithValue(err.response.data)
    }
  }
);


export const getResponseTime = createAsyncThunk(
  'dashboard/responseTime/',
  async (udata, thunkAPI) => {
    try {
      const { auth } = thunkAPI.getState()
      let tokenStr = auth.user.token;
      let response = await axios({
        url: `/api/dashboard/responseTime/`,
        method: 'get',
        headers: {
          "Authorization": `Bearer ${tokenStr}`
        }
      })

      let data = response.data;
      if (response.status === 200) {
        return data;
      }
      else if (data.code === 200) {
        return data;
      }
      else {
        return thunkAPI.rejectWithValue(data);
      }
    } catch (err) {
      if (!err.response) {
        throw err
      }

      return thunkAPI.rejectWithValue(err.response.data)
    }
  }
);


export const viewDashboardSlice = createSlice({
  name: 'viewAdminDashboard',
  initialState,
  reducers: {
    clearStateOverview: (state, { payload }) => {
      state.Overview = [];
      state.ProcessBreakDown = [];
      state.ResponseTime = [];
      state.isFetching = false;
      state.isOverviewSuccess = false;
      state.isProcessBreakDownSuccess = false;
      state.isResponseTimeSuccess = false;
      state.isError = false;
      state.errorMessage = '';
    },
  },

  extraReducers: {
    [getOverview.fulfilled]: (state, { payload }) => {

      state.Overview = payload.data;
      state.isFetching = false;
      state.isOverviewSuccess = true;
      return state;
    },
    [getOverview.pending]: (state) => {
      state.isFetching = true;
    },
    [getOverview.rejected]: (state, { payload }) => {
      state.isFetching = false;
      state.isError = true;
      if (payload) {
        state.errorMessage = payload.message;
      }
      else {
        state.errorMessage = 'Internal error';
      }
    },

    [getProcessBreakDown.fulfilled]: (state, { payload }) => {

      state.ProcessBreakDown = payload.data;
      state.isFetching = false;
      state.isProcessBreakDownSuccess = true;
      return state;
    },
    [getProcessBreakDown.pending]: (state) => {
      state.isFetching = true;
    },
    [getProcessBreakDown.rejected]: (state, { payload }) => {
      state.isFetching = false;
      state.isError = true;
      if (payload) {
        state.errorMessage = payload.message;
      }
      else {
        state.errorMessage = 'Internal error';
      }
    },

    [getAllProcessCount.fulfilled]: (state, { payload }) => {

      state.AllProcessCount = payload.data;
      state.isFetching = false;
      state.isAllProcessCountSucess = true;
      return state;
    },
    [getAllProcessCount.pending]: (state) => {
      state.isFetching = true;
    },
    [getAllProcessCount.rejected]: (state, { payload }) => {
      state.isFetching = false;
      state.isError = true;
      if (payload) {
        state.errorMessage = payload.message;
      }
      else {
        state.errorMessage = 'Internal error';
      }
    },


    [getResponseTime.fulfilled]: (state, { payload }) => {

      state.ResponseTime = payload.data;
      state.isFetching = false;
      state.isResponseTimeSuccess = true;
      return state;
    },
    [getResponseTime.pending]: (state) => {
      state.isFetching = true;
    },
    [getResponseTime.rejected]: (state, { payload }) => {
      state.isFetching = false;
      state.isError = true;
      if (payload) {
        state.errorMessage = payload.message;
      }
      else {
        state.errorMessage = 'Internal error';
      }
    },

  },
});

export const { clearStateOverview } = viewDashboardSlice.actions;

export function clearState() {

  return async (dispatch) => {
    dispatch(clearStateOverview());
  }
}

export const viewDashboardSelector = (state) => state.viewAdminDashboard;

export default viewDashboardSlice.reducer;
